<template>
    <b-overlay :show="loading" rounded="sm">

        <div v-if="subscription">

            <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3">
                <div class="col-lg-4 mb-4">
                    <div class="card border">
                        <div class="card-body h-100 my-2">
                            <div class="d-flex gap-3 align-items-center" style="">
                                <div v-if="subscription.status === 'canceled'" class="rounded-circle p-2" style="background-color: #ffa9a9b0;">
                                    <svg style="color: #c20000;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                    </svg>
                                </div>
                                <div v-else class="rounded-circle p-2" style="background-color: #a9dfffb0;">
                                    <svg style="color: #007bc2;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                    </svg>
                                </div>
                                <div class="lh-sm">
                                    <div class="fs-4">
                                        <b>
                                            <span v-if="subscription.status === 'active'">
                                                Ativa
                                            </span>
                                            <span v-else-if="subscription.status === 'canceled'">
                                                Cancelada
                                            </span>
                                            <span v-else-if="subscription.status === 'future'">
                                                Futura
                                            </span>
                                            <span v-else-if="subscription.status === 'failed'">
                                                Falha
                                            </span>
                                        </b>
                                    </div>
                                    <div class="">
                                        o status da assinatura
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-4">
                    <div class="card border">
                        <div class="card-body h-100 my-2">
                            <div class="d-flex gap-3 align-items-center">
                                <div class="rounded-circle p-2" style="background-color: #a9ffd0b0;">
                                    <svg style="color: #00c288;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div class="lh-sm">
                                    <div class="fs-4">
                                        <b>
                                            {{ totalPrice }}
                                        </b>
                                    </div>
                                    <div class="">
                                        no total por mês
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-4">
                    <div class="card border">
                        <div class="card-body h-100 my-2">
                            <div class="d-flex gap-3 align-items-center" style="">
                                <div class="rounded-circle p-2" style="background-color: #ffeba9b0;">
                                    <svg style="color: #c26e00;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                                    </svg>
                                </div>
                                <div class="lh-sm">
                                    <div class="fs-4">
                                        <b>
                                            {{ subscription.next_billing_at_formatted }}
                                        </b>
                                    </div>
                                    <div v-if="subscription.status === 'canceled'" class="">
                                        o fim da assinatura
                                    </div>
                                    <div v-else class="">
                                        a próxima cobrança
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="resume.length > 0">
                <b-table table-class="bg-white" responsive bordered :items="resume"></b-table>
            </div>

        </div>

        <subscription-empty v-else />

        <div class="mt-4 d-flex">
            <b-button @click="$emit('cancel')" variant="primary" :disabled="loading">
                <span v-if="subscription && subscription.status !== 'canceled'">
                    Atualizar
                </span>

                <span v-else>
                    Assinar
                </span>
            </b-button>

            <subscription-cancel v-if="subscription && subscription.status !== 'canceled'" class="ml-2" />
        </div>
    </b-overlay>
</template>

<script>
import price from "./mixins/price";
import subscription from "./mixins/subscription";
import SubscriptionEmpty from "./Empty";
import SubscriptionCancel from "./Cancel.vue";


export default {
    mixins: [price, subscription],
    components: {
        SubscriptionCancel,
        SubscriptionEmpty
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        resume() {
            return this.calculeResume(this.subscription.items || [], false);
        }
    },
    created() {
        this.loadSubscription();
    }
}
</script>

<style scoped>

</style>
